import { VendorSortKey, VendorsRepository } from "@/repositories/vendors.repository";
import {uuid} from "@/interfaces";
import {InviteRepository} from "@/repositories/invite.repository.ts";

export async function searchVendors(
    page: number = 1,
    pageSize: number = 10,
    name?: string,
    service?: string,
    sortKey: VendorSortKey = "name",
    sortOrder: "asc" | "desc" = "asc"
) {
    return VendorsRepository.listByCurrentOrg(
        page,
        pageSize,
        name,
        service,
        sortKey,
        sortOrder
    );
}

export async function removeVendorFromOrg(vendorId: uuid) {
    return VendorsRepository.remove(vendorId);
}

export async function inviteVendor(email: string) {
    return InviteRepository.inviteVendor(email);
}